define('presentation/common/actionModal/viewModels/deleteReportActionViewModel',[
    'common/promises/promiseFactory',
], function() {
    return function(scheduledReport) {
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _commonState = require('common/storage/commonState');

        const self = this;

        self.scheduledReport = scheduledReport;
        self.subject = scheduledReport.subject;
        self.deliveryFrequencyText = scheduledReport.deliveryFrequencyText;
        self.objectName = _commonState.typeDisplay.report.toLowerCase();

        self.activate = () => {
            return _promiseFactory.wait();
        };
    };
});
